export const rule: any = [
  {
    label: '作品名称*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入作品名称',
    title: '',
    value: 'name',
    max: 50,
  },
  {
    label: '作品类型*',
    require: true,
    type: 'picker',
    columns: [
      '海报类',
      '宣传标语类',
      '创意文案类',
    ],
    placeholder: '请选择类型',
    title: '作品类型',
    value: 'work_type',
  },
  {
    label: '作者姓名*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入姓名',
    title: '',
    value: 'author_name',
    max: 10,
  },
  {
    label: '联系方式*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入联系人电话',
    title: '',
    value: 'phone',
    reg: /^1[1-9][0-9]{9}$/,
  },
  {
    label: '单位/学校*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入所在单位或学校',
    title: '',
    value: 'sch_name',
    max: 50,
  },
  {
    label: '联系地址*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入联系地址',
    title: '',
    value: 'addr_detail',
    max: 50,
  },
  {
    label: '作品简介',
    require: false,
    type: 'textarea',
    columns: [],
    placeholder: '请输入作品简介',
    title: '',
    value: 'introduction',
    max: 0,
  },
    {
    label: '',
    require: false,
    type: '',
    columns: [],
    placeholder: '',
    title: '',
    value: 'detailcontent',
    max: 0,
  },
  {
    label: '上传作品图片',
    require: true,
    type: 'cover',
    columns: [],
    placeholder: '上传作品图片',
    title: '',
    value: 'cover',
  },
  {
    label: '新增输入框*',
    require: false,
    type: 'addtext',
    columns: [],
    placeholder: '新增输入框',
    title: '',
    value: 'addtext',
  },
];
export const field: any = {
  name: '',
  work_type: '',
  author_name: '',
  phone: '',
  sch_name: '',
  teacher_name: '',
  introduction: '',
  cover: [],
};
